import React from 'react';

const PricingPage = () => {
  return (
    <div>
      <h1>Pricing</h1>
    </div>
  );
};

export default PricingPage;
